module.exports = "images/go-diksmuide.svg";